module.exports = __webpack_public_path__ + "static/img/cover.6943ce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rides/peterpan/cover.jpg
// module id = 33
// module chunks = 0